import * as types from './mutation_types';


export const mutations = {
  // payload is error object (include isAnonymous, uid)
  [types.SIGNED_IN](state, payload) {
    if (payload) {
      state.isAnonymous = payload.isAnonymous;
      state.uid = payload.uid;
    }
  },
  // payload is error object (include folders, files)
  [types.UPDATE_LIST](state, payload) {
    if (payload) {
      state.folders = payload.folders;
      state.files = payload.files;
    }
  },
  // payload is metadata object (include key is path, value is metadata)
  [types.UPDATE_FILE_INFO](state, payload) {
    if (payload) {
      state.infos[payload.path] = payload.metadata;
    }
  },
  // payload is error object (include errCode, errMessage)
  [types.UPDATE_ERR](state, payload) {
    if (payload) {
      state.lastErrorCode = payload.errCode;
      state.lastErrorMessage = payload.errMessage;
    }
    state.isLoading = false;
  },
};

export const state = {
  isAnonymous: null,
  uid: null,
  folders: null,
  files: null,
  infos: {},
  lastErrorCode: null,
  lastErrorMessage: null,
  isLoading: false,
};
